import { Component, ElementRef, ViewChild ,HostListener  } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-uiform-pivot',
  templateUrl: './uiform-pivot.component.html',
  styleUrls: ['./uiform-pivot.component.scss'],

})
export class UiformPivotComponent extends UiformBaseComponent {
  //private sanitizer = inject(DomSanitizer);
  @ViewChild('content')
  content!: ElementRef;
  public loading: boolean = false;
  public addReport: boolean = false;
  pivotUrl: SafeResourceUrl | null = null;
  pivottable: any = '<div><div>';
  public sanitizedData: any = [];
  searchData: any = {};
  searchView: any = {};
  searchList: any = [];
  searchViewList: any = [];
  addOnDashboardReport: any = 0;
  reportId: any;
  public uiFormData: any = [];

  @ViewChild('chartIframe') chartIframe!: ElementRef;

  public reqform: any = {
    chart_type: 'html',
    margins: false,
  };

  public reportData: any = {};

  public reportform: any = {
    data: {},
  };

  public pivotform: any = {
    chart_type: 'html',
  };

  selected: any;
  alwaysShowCalendars: boolean;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));
    _self.reportId = Number(route.snapshot.paramMap.get('reportId'));
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
    this.alwaysShowCalendars = true;
  }

  override ngOnInit() {
    let _self = this;
    _self.is_paging = false;
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        if (_self.uiformId)
          _self.get(_self.uiformId, function () {
            _self.usecaseId = _self.form.data.userstoryId;
            _self.getUsecaseSchema(false, () => {
              _self.filterAttributes = _self
                .getFilterAttributes(
                  _self.usecaseAttributes,
                  _self.form.data['fields']
                )
                // .sort((a: any, b: any) =>
                //   (a.label || '').localeCompare(b.label || '')
                // );
                .sort((a: any, b: any) => (a.formIndex ?? 9999) - (b.formIndex ?? 9999));
              console.log('_self.usecaseAttributes:', _self.usecaseAttributes);
              // ✅ Load report data AFTER schema is ready
              if (_self.reportId) {
                _self.loadReportById(_self.reportId);
              }
            });
            });
          });
  }

  // loadReportById(reportId: any) {
  //   let _self = this;
  //   _self.locator.config
  //     .getProperty('endpoint.reports')
  //     .then((property: string) => {
  //       _self.locator.http.get(
  //         property + '/get/' + reportId,
  //         (res: any, error: any) => {
  //           if (error || !res.success) return;
  //           const data = res.result.data;

  //           // ✅ Pre-fill report form fields (modal)
  //           _self.reportform.data['title'] = data['title'];
  //           _self.reportform.data['subTitle'] = data['subTitle'];
  //           _self.reportform.data['description'] = data['description'];
  //           _self.addOnDashboardReport = data['addOnDashboardReport'];
  //           _self.autoUpdateReport = data['autoUpdateReport'];

  //           // ✅ Pre-fill reqform (pivot config: chart type, margins, index, columns, aggfunc)
  //           const dataJson = data['dataJson'];
  //           if (dataJson) {
  //             _self.reqform['chart_type'] = dataJson['chart_type'] || 'html';
  //             _self.reqform['margins'] = dataJson['margins'] || false;
  //             _self.reqform['index'] = dataJson['index'] || [];
  //             _self.reqform['columns'] = dataJson['columns'] || [];
  //             _self.reqform['aggfunc'] = dataJson['aggfunc'] || {};
  //           }

  //           // ✅ Pre-fill search filters
  //           if (data['searchList'] && data['searchList'].length > 0) {
  //             _self.searchList = data['searchList'];

  //             // Rebuild searchViewList for UI chips display
  //             _self.searchViewList = data['searchList'].map((e: any) => {
  //               const operator = _self.operators.find(
  //                 (op) => op.value === e.condition,
  //               );
  //               return {
  //                 field: e.field,
  //                 condition: operator ? operator.label : e.condition,
  //                 value: e.value,
  //                 rangeFrom: e.rangeFrom,
  //                 rangeTo: e.rangeTo,
  //               };
  //             });
  //           }

  //           // ✅ Auto draw the pivot with pre-filled data
  //           _self.addReport = true;

  //           _self.searchAndDraw(data['searchList']?.length > 0);
  //         },
  //       );
  //     });
  // }

  loadReportById(reportId: any) {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.reports')
      .then((property: string) => {
        _self.locator.http.get(
          property + '/get/' + reportId,
          (res: any, error: any) => {
            if (error || !res.success) return;
            const data = res.result.data;

            // ✅ Pre-fill report form fields (modal)
            _self.reportform.data['title'] = data['title'];
            _self.reportform.data['subTitle'] = data['subTitle'];
            _self.reportform.data['description'] = data['description'];
            _self.addOnDashboardReport = data['addOnDashboardReport'];
            _self.autoUpdateReport = data['autoUpdateReport'];

            // ✅ Pre-fill reqform
            const dataJson = data['dataJson'];
            if (dataJson) {
              _self.reqform['chart_type'] = dataJson['chart_type'] || 'html';
              _self.reqform['margins'] = dataJson['margins'] || false;
              _self.reqform['index'] = dataJson['index'] || [];
              _self.reqform['columns'] = dataJson['columns'] || [];
              _self.reqform['aggfunc'] = dataJson['aggfunc'] || {};
            }

            // ✅ Pre-fill search filters
            if (data['searchList'] && data['searchList'].length > 0) {
              _self.searchList = data['searchList'];
              _self.searchViewList = data['searchList'].map((e: any) => {
                const operator = _self.operators.find(
                  (op) => op.value === e.condition,
                );
                return {
                  field: e.field,
                  condition: operator ? operator.label : e.condition,
                  value: e.value,
                  rangeFrom: e.rangeFrom,
                  rangeTo: e.rangeTo,
                };
              });
            }

            _self.addReport = true;

            // ✅ CHANGED: Store uiFormData as fallback from dataJson
            _self.uiFormData = dataJson?.['data'] || [];

            // ✅ CHANGED: Decide data source based on searchList + autoUpdateReport
            if (
              (data['searchList'] && data['searchList'].length > 0) ||
              data['autoUpdateReport']
            ) {
              // Has filters OR autoUpdate — fetch fresh data then draw
              _self.searchCriteria(() => {
                _self.cleanData();
                _self.findNumericFields();
                _self.drawPivot();
              });
            // } else {
            //   // No filters, no autoUpdate — use saved dataJson.data directly
            //   _self.sanitizedData = dataJson?.['data'] || [];
            //   _self.drawPivot();
            // }
            } else {
              // No filters, no autoUpdate — saved data use karo BUT order fix karo
              const rawData = dataJson?.['data'] || [];

              const sortedAttrs = [..._self.filterAttributes].sort(
                (a: any, b: any) => (a.formIndex ?? 9999) - (b.formIndex ?? 9999)
              );
              const orderedKeys = sortedAttrs
                .filter((a: any) => a.label)
                .map((a: any) => a.label);

              _self.sanitizedData = rawData.map((item: any) => {
                const reordered: any = {};
                orderedKeys.forEach((key: string) => {
                  if (key in item) {
                    reordered[key] = item[key];
                  }
                });
                return reordered;
              });

              _self.drawPivot();
            }
          },
        );
      });
  }

  removeFormField(field: string, value: any, isKey: boolean = false) {
    if (isKey) {
      delete this.reqform[field]?.[value];
    } else if (Array.isArray(this.reqform[field])) {
      const index = this.reqform[field].indexOf(value);
      if (index > -1) this.reqform[field].splice(index, 1);
    }
  }

  updateFormField(
    field: string,
    value: any,
    aggValue?: any,
    isKey: boolean = false
  ) {
    if (!value) {
      return;
    }
    this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
    if (isKey) {
      aggValue = aggValue?.trim() || 'sum';
      this.reqform[field][value] = aggValue;
    } else {
      if (!this.reqform[field].includes(value)) {
        this.reqform[field].push(value);
      }
    }
  }

  operators = [
    { label: '=', value: 'EQ' },
    { label: '!=', value: 'NEQ' },
    { label: '>', value: 'GT' },
    { label: '<', value: 'LT' },
    { label: '>=', value: 'GTE' },
    { label: '<=', value: 'LTE' },
    { label: 'like', value: 'LIKE' },
    { label: 'between', value: 'BETWEEN' },
    { label: 'Not Null', value: 'NOT NULL' },
    { label: 'Null', value: 'NULL' },
    { label: 'Empty', value: 'EMPTY' },
    { label: 'Day', value: 'DAY' },
    { label: 'Month', value: 'MONTH' },
    { label: 'Day & Month', value: 'DAY_AND_MONTH' },
  ];

  searchAndDraw(flag: boolean) {
    let _self = this;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields;
        _self.drawPivot();
      });
    } else {
      _self.drawPivot();
    }
  }

  resetSearchValues() {
    this.reqform = {
      chart_type: 'html',
    };
    this.pivotform = {
      chart_type: 'html',
    };
    this.addReport = false;
  }

  override search(callback?: any): void {}
  svgdata: any;
  chartHtml: any;
  chartUrl: any = null;   // ✅ ADD THIS

  drawPivot() {
    let _self = this;
    _self.loading = true;
    _self.reportData = {};
    _self.form['error'] = false;
    _self.form['message'] = '';
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.chartHtml = null;
    _self.chartUrl = null;   // ✅ ADD THIS

    _self.reqform['title'] = _self.usecase['name'];
    _self.reqform['values'] = this.reqform['aggfunc']
      ? Object.keys(this.reqform['aggfunc'])
      : [];

    _self.reportData = _self.reqform;

      _self.locator.config
        .getProperty('endpoint.pivot')
        .then((property: string) => {
          let url = _self.urlRewrite(property);
          _self.reqform['data'] = _self.sanitizedData;

          let client = _self.locator.http.getClient();
          client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
            (data: any) => {
              try {
                const jsonResponse = JSON.parse(data);
                if (!jsonResponse['success']) {
                  _self.form['error'] = true;
                  _self.form['message'] = jsonResponse['message'];
                  _self.loading = false;
                  return;
                }
              }
            // catch (error) {
            //   // ✅ HTML chart aaya
            //   _self.chartHtml = data;
            //   _self.pivottable = '';

            //   // 🔥 IMPORTANT: convert HTML → iframe URL
            //   const blob = new Blob([data], { type: 'text/html' });
            //   const url = URL.createObjectURL(blob);

            //   _self.chartUrl =
            //     this.sanitizer.bypassSecurityTrustResourceUrl(url);
            // }
            catch (error) {

              // 🔥 Detect: Chart ya Table
              if (data.includes('Plotly.newPlot') || data.includes('plotly')) {

                // ✅ Chart case
                _self.chartHtml = data;
                _self.pivottable = '';

                const blob = new Blob([data], { type: 'text/html' });
                const url = URL.createObjectURL(blob);

                _self.chartUrl =
                  this.sanitizer.bypassSecurityTrustResourceUrl(url);

              } else {

                //  Table case
                _self.pivottable = data;
                _self.chartUrl = null;
                    }
              }

              _self.loading = false;
              _self.addReport = true;
            },
            (error: any) => {
            _self.form['error'] = true;
            _self.form['message'] = 'Error loading pivot table';
              _self.loading = false;
              _self.addReport = true;
            console.error('Error:', error);
            }
          );
        });
    }

  public cleanData(): any {
    let _self = this;

    // ✅ formIndex ke according sort karo pehle
    const sortedAttributes = [..._self.usecaseAttributes].sort((a: any, b: any) => {
      const aIndex = a['formIndex'] ?? 9999;
      const bIndex = b['formIndex'] ?? 9999;
      return aIndex - bIndex;
    });


    // const allowedKeysMap = _self.filterAttributes.reduce(
    //   (map: any, attr: any) => {
    //     if (attr['code'] && attr['label']) {
    //       map[attr['code']] = attr['label'];
    //     }
    //     return map;
    //   },
    //   {}
    // );

    const allowedKeysMap = sortedAttributes.reduce(
      (map: any, attr: any) => {
        if (attr['code'] && attr['label']) {
          map[attr['code']] = attr['label'];
        }
        return map;
      },
      {}
    );

    _self.sanitizedData = _self.usecaseData.map((item: any) => {
      const sanitizedItem: any = {};
      Object.keys(allowedKeysMap).forEach((key: string) => {
        if (key in item) {
          sanitizedItem[allowedKeysMap[key]] = item[key];
        }
      });

      return sanitizedItem;
    });
  }

  // Function to find all numeric fields
  findNumericFields = () => {
    const numericFields = new Set();
    this.sanitizedData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number') {
          numericFields.add(key);
        }
      });
    });
    return Array.from(numericFields);
  };

  resetreportform() {
    // ✅ If editing existing report, don't reset the form data
    if (this.reportId) {
      this.reportform.error = false;
      this.reportform.message = '';
      return;
    }

    this.reportform.error = false;
    this.reportform.message = '';
    this.reportform = {
      data: {},
    };
  }

  saveReport(callback?: any) {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.reports')
      .then((property: string) => {
        let url = property + '/save';
        _self.reportform.data['applicationId'] = _self.appId;
        _self.reportform.data['userstoryId'] = _self.usecaseId;
        _self.reportform.data['uiFormId'] = _self.uiformId;
        _self.reportform.data['formTitle'] = _self.usecase?.['name'];
        _self.reportform.data['dataJson'] = _self.reportData;
        _self.reportform.data['searchList'] = _self.searchList;
        _self.reportform.data['autoUpdateReport'] = this.autoUpdateReport;
         _self.reportform.data['addOnDashboardReport'] = this.addOnDashboardReport;
         if (_self.reportId) {
          _self.reportform.data['id'] = _self.reportId;
         }
        _self.locator.http.post(
          url,
          _self.reportform.data,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }
            _self.reportform.error = !res.success;
            _self.reportform.message = res.message;
            _self.reportform.inputerror = res.result.inputerror;
            if (res.success) {
              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }
  checkReportLabel(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    this.reportform.data['title'] = value;
  }

  /**
   * Allow Capital the whole word
   * @param str
   * @returns
   */
  capitalizeUsecaseWords(str: string): string {
    return str
      .split(' ')
      .map(
        (word) =>
          word === word.toUpperCase()
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' '); // Join the array back into a string with spaces
  }

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' ');
  }

  public selectedSearchAtt: any;

  getType(value: any) {
    let _self = this;
    _self.filterAttributes.forEach((e: any) => {
      if (e.code === value) {
        this.searchData['value'] = '';
        if (e?.type == 'long' || e?.type == 'expression') {
          _self.selectedSearchAtt = 'number';
        } else {
          _self.selectedSearchAtt = e?.type;
        }
      }
    });
  }

  formattedDate: string | undefined;

  async addSearchData() {
    let _self = this;

     if (_self.selectedSearchAtt === 'date' && _self.searchData['condition'] != 'BETWEEN') {
      if (!_self.searchData['value']) {
        alert('Date is empty');
        return;
      } else {
        const searchDate = new Date(_self.searchData['value']);
        const currentDate = new Date();

        // Creating a new Date object for currentDate with time set to midnight
        const formattedDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );

        // Create a Date object for yesterday
        const yesterDate = new Date();
        searchDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        yesterDate.setDate(currentDate.getDate() - 1);
        yesterDate.setHours(0, 0, 0, 0); // Make sure yesterDate is also at midnight

        if (searchDate.getTime() === currentDate.getTime()) {
          _self.searchData['date'] = 'today';
        } else if (searchDate.getTime() === yesterDate.getTime()) {
          _self.searchData['date'] = 'yesterday';
        } else {
          // You can handle the case where it's neither today nor yesterday if needed
          console.log('The date is neither today nor yesterday.');
        }
      }
    }

    if (_self.searchData['rangeDate']) {
      _self.searchData['rangeFrom'] =
        _self.searchData.rangeDate.startDate.format('YYYY-MM-DD');
      _self.searchData['rangeTo'] =
        _self.searchData.rangeDate.endDate.format('YYYY-MM-DD');
      console.log(_self.searchData['rangeFrom'], _self.searchData['rangeTo']);
    }

    if (!_self.searchData['field']) {
      alert('Field is empty');
      return;
    } else if (!_self.searchData['condition']) {
      alert('Condition is empty');
      return;
    } else if (_self.searchData['condition'] === 'BETWEEN') {
      _self.searchData['value'] = undefined;
      _self.searchData['rangeDate'] = undefined;
      if (!_self.searchData['rangeTo']) {
        alert('Value is emptyaa');
        return;
      } else if (!_self.searchData['rangeFrom']) {
        alert('Value is emptyqqq');
        return;
      } else {
        this.operators.forEach(async (e: any) => {
          if (_self.searchData['condition'] === e.value) {
            let searchViewData = {
              field: _self.searchData['field'],
              condition: e.label,
              rangeFrom: _self.searchData['rangeFrom'],
              rangeTo: _self.searchData['rangeTo'],
              ...(_self.searchViewList.length > 0
                ? { logicalOperator: _self.currentLogicalOperator }
                : {}),
            };
            _self.searchViewList.push(searchViewData);
          }
        });
        _self.searchList.push({
          ..._self.searchData,
          ...(_self.searchList.length > 0
            ? { logicalOperator: _self.currentLogicalOperator }
            : {}),
        });
        _self.searchData = {};
        _self.searchView = {};
        _self.selectedSearchAtt = undefined;
        _self.currentLogicalOperator = '';
      }
    } else {

      if (this.selectedSearchAtt === 'decimal') {
        _self.searchData['value'] = parseFloat(_self.searchData['value']);
      }

       if (['NULL','NOT NULL', 'EMPTY', 'NULL'].indexOf(_self.searchData['condition']) === -1 && !_self.searchData['value']) {
      alert('Value is empty');
      return;
     }

    if (_self.searchData['condition'] === 'EMPTY') {
    if (this.selectedSearchAtt === 'number') {
        _self.searchData['value'] = 0;
    }
   }
      this.operators.forEach(async (e: any) => {
        if (_self.searchData['condition'] === e.value) {
          let searchViewData = {
            field: _self.searchData['field'],
            condition: e.label,
            value: _self.searchData['value'],
            ...(_self.searchViewList.length > 0
              ? { logicalOperator: _self.currentLogicalOperator }
              : {}),
          };
          _self.searchViewList.push(searchViewData);
        }
      });
      _self.searchList.push({
        ..._self.searchData,
        ...(_self.searchList.length > 0
          ? { logicalOperator: _self.currentLogicalOperator }
          : {}),
      });
      _self.searchData = {};
      _self.searchView = {};
      _self.selectedSearchAtt = undefined;
      _self.currentLogicalOperator = '';
    }
  }

  removeSearchData(index: any) {
    if (index > -1) this.searchList.splice(index, 1);
    if (index > -1) this.searchViewList.splice(index, 1);
  }

  resetSearchCriteria() {
    this.searchList = [];
    this.searchData = {};
    this.searchView = {};
    this.searchViewList = [];
  }

  searchCriteria(callback?: any) {
    let _self = this;

    _self.usecaseData = [];
    _self.sanitizedData = [];
    _self.searchList.forEach((e: any) => {
      if (e?.date) {
        const currentDate = new Date();
        if (e?.date === 'today') {
          e['value'] = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
        } else if (e?.date === 'yesterday') {
          const yesterday = new Date(currentDate.getTime() - 1);
          e['value'] = this.datePipe.transform(yesterday, 'yyyy-MM-dd');
        }
      }
    });

    let searchCriteria = {
      searchList: _self.searchList,
    };

    let url = _self.apiurl + '/searchCriteria';

    this.locator.http.post(
      url,
      searchCriteria,
      function (res: any, error: any) {
        if (error) {
          if (callback) {
            callback(error);
          }
          return;
        }

        if (res.success) {
          _self.usecaseData = res.result['data'];
          if (callback) {
            callback();
          }
        }

        if (callback) {
          callback();
        }
      }
    );
  }

  getButtonLabels(type: string): string {
    const typeMap: { [key: string]: string } = {
      text: 'T',
      number: 'N',
      long: 'N',
      date: 'D',
      decimal: 'N',
      doc: 'T',
      email: 'E',
      expression: 'N',
      file: 'I',
      list: 'C',
      map: 'C',
      object: 'O',
      password: 'P',
      phone: 'T',
      textarea: 'T',
      url: 'T',
    };
    return typeMap[type];
  }

  getButtonClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      text: 'text-bg-success',
      number: 'text-bg-primary',
      date: 'text-bg-warning',
      long: 'text-bg-primary',
      decimal: 'text-bg-primary',
      doc: 'text-bg-primary',
      email: 'text-bg-success',
      expression: 'text-bg-primary',
      file: 'text-bg-primary',
      list: 'text-bg-primary',
      map: 'text-bg-primary',
      object: 'text-bg-primary',
      password: 'text-bg-primary',
      phone: 'text-bg-primary',
      textarea: 'text-bg-primary',
      url: 'text-bg-primary',
    };
    return typeClassMap[type] || 'text-bg-success'; // Default grey
  }

  dropdownOpen: boolean = false;

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectColumn(value: any, key: string) {
    this.pivotform[key] = value;
    if (value['type'] === 'text') {
      this.pivotform['aggfunc'] = 'count';
    }
  }

  selectSearch(value: any, key: string) {
    this.searchData[key] = value['code'];
    this.searchView[key] = value['label'];
    if (key === 'field') {
      this.getType(this.searchData['field']);
    }
  }

  ranges: any = {
    Today: [new Date(), new Date()],
    Yesterday: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1)),
    ],
    'This Week': [
      new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
      new Date(
        new Date().setDate(new Date().getDate() + (6 - new Date().getDay()))
      ),
    ],
    'Last Week': [
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
      ),
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
      ),
    ],
    'This Month': [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ],
    'Last Month': [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    ],
  };

  transform(value: string, limit: number = 15): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }

  filterRowColumns() {
    const allowedTypes = [
      'text',
      'date',
      'object',
      'email',
      'time',
      'url',
      'map',
      'list',
    ];
    return this.filterAttributes.filter((e: any) =>
      allowedTypes.includes(e['type'])
    );
  }

autoUpdateReport: any = 0;
intervalId: any;

toggleAutoUpdate() {
  // Start or stop auto-refresh based on the toggle state
  if (this.autoUpdateReport) {
    this.intervalId = setInterval(() => {
      this.searchAndDraw(true);
    }, 30000);
  } else {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

// public exportPDFData(): void {
//   const _self = this;
//   if (!_self.pivottable || Object.keys(_self.pivottable).length === 0) {
//       if (this.svgdata) {
//         const reader = new FileReader();
//         reader.onload = () => {
//           const svgText = reader.result as string;
//           _self.pivottable = svgText;
//           _self.sendPDFRequest();
//         };
//         reader.readAsText(this.svgdata);
//       return;
//       } else {
//         _self.sendPDFRequest();
//    }
//   } else {
//     _self.sendPDFRequest();
//     }
//   }
  public async exportPDFData(): Promise<void> {
  const _self = this;

    // =========================================
    // 📊 CHART CONVERSION (AGAR CHART HAI TO)
    // =========================================
    if (this.chartUrl) {
      try {
        await this.waitForIframeLoad();

        const iframe = this.chartIframe.nativeElement;
        const iframeWin = iframe.contentWindow;
        const Plotly = (iframeWin as any)?.Plotly;

        if (Plotly) {
          let chartDiv = iframeWin?.document?.getElementById('plotly-chart');
          if (!chartDiv) {
            chartDiv = iframeWin?.document?.querySelector('.plotly-graph-div');
          }
        //  new legend
          await Plotly.relayout(chartDiv, {

            autosize:false,
            width: 1200,
            height: 600, // 👈 chart height increase

            margin: {
              t: 80,
              b: 80,
              l: 80,
              r: 400 // 👈 more space for legend
            },

            legend: {
              orientation: 'v',
              x: 1.02,
              y: 1,
              xanchor: 'left',
              yanchor: 'top',
              font: {
                size: 8
              },
              itemwidth: 20,
              // 👇 important
              tracegroupgap:0
            }
          });
          // end of new

          if (chartDiv) {
            const svgUrl = await Plotly.toImage(chartDiv, {
              format: 'svg',
              width: 1000,
              height: 600,
              scale: 1
            });

            let svgText = '';
            const commaIndex = svgUrl.indexOf(',');
            if (commaIndex !== -1) {
              const encodedSvg = svgUrl.substring(commaIndex + 1);
              svgText = decodeURIComponent(encodedSvg);
            }

            svgText = svgText
              .replace(/<\?xml[^>]*\?>/g, '')
              .replace(/<!--[\s\S]*?-->/g, '')
              .replace(/data:image\/svg\+xml,?/gi, '');

            _self.pivottable = svgText;
            console.log('✅ Chart converted to SVG');
            _self.sendPDFRequest();
            return;
          }
        }
      } catch (error) {
         console.error('Chart conversion failed:', error);
      }
    }

    // =========================================
    // 📋 TABLE / SVG DATA / PIVOT TABLE
    // =========================================
  if (!_self.pivottable || Object.keys(_self.pivottable).length === 0) {
      if (this.svgdata) {
        const reader = new FileReader();
        reader.onload = () => {
          const svgText = reader.result as string;
          _self.pivottable = svgText;
          _self.sendPDFRequest();
        };
        reader.readAsText(this.svgdata);
      return;
      } else {
        _self.sendPDFRequest();
   }
  } else {
    _self.sendPDFRequest();
    }
  }



  public sendPDFRequest() {
    let _self = this;

  this.locator.config
    .getProperty('endpoint.api.v1')
    .then((property: string) => {
      const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
      let sid = localStorage.getItem(keySuffix + 'sessionId');
      if (!sid) {
        sid = '0';
      }
     const url = `${property}/${this.appId}/${this.uiformId}/reportPdf;jsessionid=${sid}`;

      // Prepare HTML content for PDF generation
      const tableStyle = `
        <style>
          @page {
            size: A4 landscape;
            margin: 5mm;
          }
          body {
            margin: 0;
            padding: 0;
          }
          table {
            border-collapse: collapse;
            width: 100%;
            table-layout: fixed;
            page-break-inside: auto;
            font-family: 'NotoSerifGujarati', sans-serif;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 3px;
            font-size: 7px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            text-align: center;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
        </style>
      `;

      const htmlContent = `
        <html>
          <head>${tableStyle}</head>
          <body>
            <div style="width: 100%; overflow: hidden;">
              ${_self.pivottable}
            </div>
          </body>
        </html>
      `;

      // Send the HTML content to the backend to generate PDF
      _self.locator.http
        .getClient()
          .post(url, { html: htmlContent }, { responseType: 'blob' })
        .subscribe(
          (data: any) => {
            _self.downloadDataAsFile(data, 'export.pdf');
          },
          (error: any) => {
              alert(
                'Failed to generate PDF. Please try again or contact support.'
              );
          }
        );
    });
}

/**
 * Downloads the received data as a PDF file.
 *
 * @param data     The PDF blob data received from the backend.
 * @param fileName The name of the file to save as.
 */
public downloadDataAsFile(data: any, fileName: string): void {
  const file = new Blob([data], { type: 'application/pdf' });
  const downloadAnchor = document.createElement('a');
  downloadAnchor.style.display = 'none';
  const fileURL = URL.createObjectURL(file);
  downloadAnchor.href = fileURL;
  downloadAnchor.download = fileName;
  downloadAnchor.click();
}

private waitForIframeLoad(): Promise<void> {
    return new Promise((resolve) => {
      const iframe = this.chartIframe?.nativeElement;
      if (!iframe) {
        resolve();
        return;
      }

      if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
        resolve();
      } else {
        iframe.addEventListener('load', () => resolve());
      }
    });
  }

  chartTypes = [
  { value: 'html', icon: '🔲', label: 'PIVOT.CHART_TYPES.TABLE' },
  { value: 'bar', icon: '📊', label: 'PIVOT.CHART_TYPES.BAR' },
  { value: 'line', icon: '📈', label: 'PIVOT.CHART_TYPES.LINE' },
  { value: 'area', icon: '📉', label: 'PIVOT.CHART_TYPES.AREA' },
  { value: 'pie', icon: '⭕', label: 'PIVOT.CHART_TYPES.PIE' },
];

aggregationTypes = [
  { value: 'sum', label: 'PIVOT.AGGREGATION_TYPES.SUM' },
  { value: 'mean', label: 'PIVOT.AGGREGATION_TYPES.MEAN' },
  { value: 'count', label: 'PIVOT.AGGREGATION_TYPES.COUNT' },
  { value: 'min', label: 'PIVOT.AGGREGATION_TYPES.MIN' },
  { value: 'max', label: 'PIVOT.AGGREGATION_TYPES.MAX' },
  { value: 'std', label: 'PIVOT.AGGREGATION_TYPES.STD' },
  { value: 'median', label: 'PIVOT.AGGREGATION_TYPES.MEDIAN' }
];

// Component mein
  selectedDay: string = 'Today';
  selectedMonth: string = 'CURRENT';

days = [ 'Today', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

months = [
    { value: 'CURRENT', name: 'Current Month' },
  { value: '01', name: 'January' },
  { value: '02', name: 'February' },
  { value: '03', name: 'March' },
  { value: '04', name: 'April' },
  { value: '05', name: 'May' },
  { value: '06', name: 'June' },
  { value: '07', name: 'July' },
  { value: '08', name: 'August' },
  { value: '09', name: 'September' },
  { value: '10', name: 'October' },
  { value: '11', name: 'November' },
  { value: '12', name: 'December' }
];

onConditionChange() {
  // Reset selections when condition changes
  this.selectedDay = '';
  this.selectedMonth = '';
}

onDayChange() {
  if (this.selectedDay) {
     const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = String(date.getMonth() + 1).padStart(2, '0');

      let day = this.selectedDay;

      // FIX ONLY FOR "today"
      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      // this.searchData[
      //   'value'
      // ] = `${currentYear}-${currentMonth}-${this.selectedDay}`;

        this.searchData[
          'value'
        ] = `${currentYear}-${currentMonth}-${day}`;
  }
}

onMonthChange() {
  if (this.selectedMonth) {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentDay = String(date.getDate()).padStart(2, '0');

      //  const month = String(this.selectedMonth).padStart(2, '0');

      let month = this.selectedMonth;

      console.log('month : ', month);

      //  FIX ONLY FOR "THIS MONTH"
      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      // this.searchData[
      //   'value'
      // ] = `${currentYear}-${this.selectedMonth}-${currentDay}`;

      this.searchData['value'] = `${currentYear}-${month}-${currentDay}`;
  }
}

onDayMonthChange() {
  if (this.selectedDay && this.selectedMonth) {
       const date = new Date();
    // Current year + selected month + selected day (e.g., "2024-07-15")
    const currentYear = new Date().getFullYear();

       let month = this.selectedMonth;
       let day = this.selectedDay;

      console.log('month : ', month);

      // FIX ONLY FOR "THIS MONTH"
      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      //  FIX ONLY FOR "today"
      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      //  this.searchData[
      //    'value'
      //  ] = `${currentYear}-${this.selectedMonth}-${this.selectedDay}`;

      this.searchData[
        'value'
      ] = `${currentYear}-${month}-${day}`;
  }
}

  dayDropdownOpen = false;

toggleDayDropdown() {
  this.dayDropdownOpen = !this.dayDropdownOpen;
}

selectDay(day: string) {
  this.selectedDay = day;
  this.dayDropdownOpen = false;
  this.onDayChange(); // <-- 🔥 your logic still works
}
monthDropdownOpen = false;

toggleMonthDropdown() {
  this.monthDropdownOpen = !this.monthDropdownOpen;
}

selectMonth(month: any) {
  this.selectedMonth = month.value;
  this.monthDropdownOpen = false;
  this.onMonthChange();
}
selectDayForDayMonth(day: string) {
  this.selectedDay = day;
  this.dayDropdownOpen = false;
  this.onDayMonthChange();
}

selectMonthForDayMonth(month: any) {
  this.selectedMonth = month.value;
  this.monthDropdownOpen = false;
  this.onDayMonthChange();
}

getMonthName(value: string) {
  return this.months.find(m => m.value === value)?.name;
}

  // Close when clicking outside
  @HostListener('document:click')
  onClickOutside() {
    this.dayDropdownOpen = false;
    this.monthDropdownOpen = false;
  }

  // raman search view pivot also change in ts start
  // Helper method to get full field object by code
  getSelectedFieldCode(fieldCode: string): any {
    if (!fieldCode) return null;
    return this.filterAttributes.find((attr: any) => attr.code === fieldCode);
  }

  // Selection change handler
  onSelectChange(event: any) {
    this.selectSearch(event.value, 'field');
  }

  // Optional: keep if you want to debug later, otherwise remove
  onSelectOpened(isOpen: boolean) {
    // Debug code removed as everything is working
  }

setAddOnDashboard(checked: boolean) {
  this.addOnDashboardReport = checked ? 1 : 0;
}

public currentLogicalOperator: string = '';

setLogicalOperator(op: string) {
  this.currentLogicalOperator = op;
}

}
